export const OWNER = 'OWNER'
export const RECIPIENT = 'RECIPIENT'
